import React, { useRef, Children, isValidElement } from 'react';
import { motion, useInView } from 'framer-motion';
interface SectionRevealProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
}
export function SectionReveal({
  children,
  className = '',
  delay = 0
}: SectionRevealProps) {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15,
        delayChildren: delay
      }
    }
  };
  const childVariants = {
    hidden: {
      opacity: 0,
      y: 60
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.8,
        ease: 'easeOut'
      }
    }
  };
  return <motion.div ref={ref} className={className} variants={containerVariants} initial="hidden" animate={isInView ? 'visible' : 'hidden'} data-id="element-192">
      {Children.map(children, child => {
      if (!isValidElement(child)) return child;
      return <motion.div variants={childVariants} data-id="element-193">{child}</motion.div>;
    })}
    </motion.div>;
}